module.exports = __webpack_public_path__ + "src/assets/img/key-label.daccbbc1.svg";